import React, { createContext, useContext } from 'react'
import { useDeviceSelector } from 'src/hooks/useDevice' // <-- make sure you import this

// Device type constants
export const deviceTypes = {
  all: 'all',
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
} as const

// Type alias for device keys
export type DeviceType = typeof deviceTypes[keyof typeof deviceTypes]

// Context value interface
interface PageDeviceContextValue {
  selectedDevice: DeviceType
  setSelectedDevice: (device: DeviceType) => void
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isAll: boolean
}

// Create the context
const PageDeviceContext = createContext<PageDeviceContextValue | undefined>(undefined)

// Provider that uses your hook internally
export const PageDeviceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const device = useDeviceSelector()
  return <PageDeviceContext.Provider value={device}>{children}</PageDeviceContext.Provider>
}

// Hook to use in components
export const usePageDevice = () => {
  const context = useContext(PageDeviceContext)
  if (!context) throw new Error('usePageDevice must be used within a PageDeviceProvider')
  return context
}
